import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export const trainerCarousel = () => ({
   initTrainerCarousel: () => {
    const swiperElement = document.querySelector(".instructor-carousel") as HTMLElement;
    
    
    new Swiper(swiperElement, {
        slidesPerView: 1.3,
        spaceBetween: 1,
        modules: [Navigation, Pagination],
        pagination: {
            el: swiperElement.querySelector<HTMLElement>('.swiper-pagination'),
            clickable: true,
        },
        navigation: {
            nextEl: swiperElement.querySelector<HTMLElement>('.swiper-button-next'),
            prevEl: swiperElement.querySelector<HTMLElement>('.swiper-button-prev'),
        },

        breakpoints: {
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 4,
            }
        }
    });
   }
})

